import { Dialog } from 'construct-ui';
import MultiSelectComponent from '../../../components/multi-select/multi-select.component';
import SingleSelectComponent from '../../../components/single-select/single-select.component';
import SelectUserComponent from '../../../components/user/select-user.component';
import { codeMasterType } from '../../../config/constants';
import codeMasterModel from '../../../models/common/code-master.model';
import RawDataModel from '../../../models/raw-data/raw-data.model';
import UserRoleModel from '../../../models/user/user-role.model';
import ViewBase from '../../view-base.view';

export default function AddRawDataAccessDialog() {
  ViewBase.call(this);

  const ID_ADD_ACCESS_FORM = 'AddAccessForm'
  const DEFAULT_INPUT_DATA_MODEL = {
    selectedDataType: {},
    templates: [],
    selectedTemplate: {},
    selectedUsers: [],
    userTypes: [
      { name: 'User', code: "User" },
      { name: "User Role", code: "UserRole" }
    ],
    selectedUserType: {
      name: "User", code: "User"
    },
    userRoleOptionList: [],
    selectedUserRoleList: [],
  }

  let dataTypes = [];
  let inputDataModel = structuredClone(DEFAULT_INPUT_DATA_MODEL);
  let resultTableHeader = inputDataModel.selectedUserType.name;
  let needRefresh = false;
  let onClose = (needRefresh) => { }

  const handleClose = () => {
    onClose(needRefresh);
    if (needRefresh === true) {
      inputDataModel = structuredClone(DEFAULT_INPUT_DATA_MODEL)
    }
  }

  const requestBody = {
    get rawDataId() {
      return inputDataModel.selectedTemplate.id
    },
    get userType() {
      return inputDataModel.selectedUserType.code
    },
    get user() {
      if (inputDataModel.selectedUserType?.code === 'UserRole') {
        return inputDataModel.selectedUserRoleList.map(({ code }) => code).join('^');
      }
      return inputDataModel.selectedUsers.map(({ userID }) => userID).join('^');
    }
  }

  const handleSave = (e) => {
    // Form validation
    if (!this.validateForm(e, '#' + ID_ADD_ACCESS_FORM)) {
      return false;
    }

    this.showLoading();
    RawDataModel.saveRawDataAccess(requestBody)
      .then((result) => {
        needRefresh = true;
        this.showMessage(this.getText('EM00000004', 'Success'), '', handleClose);
      }).catch((error) => {
        needRefresh = false;
        this.showErrorMessage(this.getText(error.response[0].code, error.response[0].message), '', handleClose);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const getDataTypeList = () => {
    this.showLoading();
    codeMasterModel.getByCategoryV2({ category: codeMasterType.rawDataType })
      .then((result) => {
        if (result) {
          dataTypes = result.map(({ name }) => ({ code: name, name }));
        }
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const getTemplateList = (dataType) => {
    this.showLoading();
    RawDataModel.getRawDataTemplateList(dataType)
      .then((result) => {
        if (result) {
          inputDataModel.templates = result;
        }
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const getUserRoleList = () => {
    UserRoleModel.getUserRoleList(
      (result) => {
        if (result) {
          inputDataModel.userRoleOptionList = result
        }
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  const _initControls = () => {
    getDataTypeList();
  }

  return {
    oninit: (vnode) => {
      _initControls();
      onClose = vnode.attrs.onClose;
    },
    view: ({ attrs: { isOpen } }) => {
      return m(Dialog, {
        class: 'cui-dialog-xxl',
        closeOnOutsideClick: false,
        isOpen: isOpen,
        onClose: handleClose,
        title: this.getText("LT00001193", "Add Access"),
        content: [
          m('.row',
            m('.col-12',
              m('.card.mb-3',
                m('.card-body',
                  m('form.row.g-4.needs-validation[novalidate="novalidate"]',
                    {
                      id: ID_ADD_ACCESS_FORM,
                      onsubmit: handleSave
                    },
                    m('.row.g-4.mt-2',
                      m('.col-md-6.position-relative',
                        m('label.form-label.mandatory[for="dataType"]', this.getText("LT00000013", "Data Type")
                        ),
                        m(SingleSelectComponent, {
                          id: 'dataType',
                          required: true,
                          items: dataTypes,
                          selectedItem: inputDataModel.selectedDataType,
                          onSelect: (selectedItem) => {
                            inputDataModel.selectedDataType = selectedItem;
                            if (selectedItem.code) {
                              getTemplateList(selectedItem.code)
                            }
                            if (inputDataModel.selectedTemplate.id) {
                              inputDataModel.selectedTemplate = {}
                            }
                          }
                        }),
                        m('.invalid-tooltip', this.getText("EM00000817", "Please select a Data Type")),
                      ),
                      m('.col-md-6.position-relative',
                        m('label.form-label.mandatory[for=template]', this.getText("LT00000202", "Template")
                        ),
                        m(SingleSelectComponent, {
                          id: 'template',
                          itemKey: 'id',
                          required: true,
                          disabled: inputDataModel.selectedDataType?.code ? false : true,
                          items: inputDataModel.templates,
                          selectedItem: inputDataModel.selectedTemplate,
                          onSelect: (selectedItem) => {
                            inputDataModel.selectedTemplate = selectedItem;
                          }
                        }),
                        m('.invalid-tooltip', this.getText("EM00000818", "Please select a template")),
                      ),
                    ),
                    m('.row.g-4.mt-2',
                      m('.col-md-6.position-relative',
                        m('label.form-label.mandatory[for=userType]', this.getText("LT00000193", "User Type")),
                        m(SingleSelectComponent, {
                          id: 'userType',
                          required: true,
                          items: inputDataModel.userTypes,
                          selectedItem: inputDataModel.selectedUserType,
                          allowEmpty: false,
                          onSelect: (selectedItem) => {
                            inputDataModel.selectedUserType = selectedItem;
                            if (selectedItem.code === "UserRole") {
                              inputDataModel.selectedUsers = []
                              getUserRoleList()
                            } else {
                              inputDataModel.selectedUserRoleList = []
                            }
                          }
                        }),
                        m('.invalid-tooltip', this.getText("EM00000818", "Please select a template")),
                      ),
                      inputDataModel.selectedUserType?.code === 'UserRole' &&
                      m('.col-md-6.position-relative',
                        m('label.form-label.mandatory[for=userRole]', this.getText("LT00000060", "User Role")),
                        m(MultiSelectComponent, {
                          id: 'userRole',
                          required: true,
                          disabled: inputDataModel.selectedUserType?.code ? false : true,
                          items: inputDataModel.userRoleOptionList,
                          selectedItems: inputDataModel.selectedUserRoleList,
                          onSelect: (s) => {
                            inputDataModel.selectedUserRoleList = s;
                          }
                        }),
                        m('.invalid-tooltip', this.getText("EM00000291", "User Role required.")),
                      ),
                      inputDataModel.selectedUserType?.code === 'User' &&
                      m('.col-md-6.position-relative',
                        m('label.form-label.mandatory[for=user]', this.getText("LT00000009", "User")),
                        m(SelectUserComponent, {
                          id: 'user',
                          default: {
                            userStatusCode: '0001'
                          },
                          disabled: inputDataModel.selectedUserType?.code ? false : true,
                          required: true,
                          onSelect: (u) => {
                            inputDataModel.selectedUsers = u;
                          },
                          selectedUserList: inputDataModel.selectedUsers,
                        }),
                        m('.invalid-tooltip', this.getText("EM00000314", "Please select user(s)")),
                      ),
                    )
                  )
                )
              )
            )
          ),
          this.getBaseViews()
        ],

        footer: m('.col-md-12.d-flex.justify-content-end.gap-2',
          m('button.btn.btn-white', {
            onclick: handleClose
          }, this.getText('LT00000057', "Cancel")),
          m('button.btn.btn-primary[type="submit"]', { form: ID_ADD_ACCESS_FORM }, this.getText('LT00000022', "Save"))
        )
      })

    }
  }
}